import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const LinkStyled = styled.div`
  color: #5ab5e0;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 10px;
`;

const StyledContainer = styled.div`
  padding: 15px 10px 5px;
  background-color: #def0f9;
`;

function AccordionGroup({ field }) {
  const [showContainer, setShowContainer] = useState(false);
  const { children, openContainerText, closeContainerText } = field;

  const handleContainerClick = useCallback(() => {
    setShowContainer(!showContainer);
  }, [showContainer]);

  return (
    <>
      <LinkStyled onClick={handleContainerClick}>
        {showContainer ? closeContainerText : openContainerText}
      </LinkStyled>
      {showContainer && <StyledContainer>{children}</StyledContainer>}
    </>
  );
}

AccordionGroup.propTypes = {
  field: PropTypes.object,
};

export default AccordionGroup;
